// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2UF0f","top":"styles_top__3UrOh","left":"styles_left__23vGk","description":"styles_description__lamFY"};